import { render, staticRenderFns } from "./PageReferrals.vue?vue&type=template&id=1e2e10c2&"
import script from "./PageReferrals.vue?vue&type=script&lang=ts&"
export * from "./PageReferrals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports